export default __webpack_public_path__ + "static/media/avatar-s-11.1d46cc62.jpg";